module.exports = __webpack_public_path__ + "static/media/cq_messaggio_letto b.f90d262d.svg";